export default __webpack_public_path__ + "static/media/Tools.c18f7f53.svg";